import { SearchEffects } from './search.effect';

export const effects = [SearchEffects];

export * from './search.effect';
